export { useRegionConfig } from './useRegionConfig';
